<span [ngClass]="{'d-none': !commentIsPresent}" class="pe-1">
    <i class="fas fa-comment fa-flip-horizontal"
       [appBsTooltip]="tooltipTitle"></i>
</span>
